module.exports = __webpack_public_path__ + "static/media/time-session-90m.0e1c19a8.svg";